import { motion } from 'framer-motion'
import { useForm } from 'react-hook-form'

import { useManagementCreateAddress } from '@apps-common/apis/management/address'
import { PageSubtitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundedSm } from '@apps-common/components/elements/button'
import { CheckboxInputSM, InputSM } from '@apps-common/components/elements/form'
import { VertSpacerLg } from '@apps-common/components/layout'
import { ModalContainer } from '@apps-common/components/modals/modal'
import { NavbarIcon } from '@apps-common/components/navigation'
import { ModalDismiss } from '@apps-common/config/modal'
import { IEntityAddressModel } from '@apps-common/types/management/entity-address'

interface IProps {
  entityId: string
}

export const EntityAddressCreateModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: IProps
}) => {
  const { mutate: createAddress, isPending: createAddressIsPending } = useManagementCreateAddress(true, (data) => {
    onDismiss(JSON.stringify(data), ModalDismiss.Confirm)
  })

  const { entityId } = componentProps

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<IEntityAddressModel>({
    mode: 'onChange',
    reValidateMode: 'onChange'
  })

  const onSubmit = (values: IEntityAddressModel) => {
    // console.log(values)
    createAddress({ model: { ...values, entityId } })
  }

  return (
    <ModalContainer innerClasses='sm:min-h-[min(620px,100vh)]'>
      <div className='relative flex items-center justify-between pl-[7px]'>
        <PageSubtitle classes='text-secondary-content'>Create address</PageSubtitle>
        <NavbarIcon icon='close' iconClasses='text-secondary-content' callback={() => onDismiss(null, ModalDismiss.Cancel)} />
      </div>
      <VertSpacerLg />
      <motion.div layout>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <InputSM
            type='text'
            placeholder='Enter street address'
            label='Street'
            id='streetAddress1'
            showLabel
            disabled={createAddressIsPending}
            registration={register('streetAddress1', {
              required: {
                value: true,
                message: 'Required'
              }
            })}
            errors={errors.streetAddress1 as any}
          />
          <InputSM
            type='text'
            placeholder='Enter street address contd'
            label='Street contd'
            id='streetAddress2'
            showLabel
            disabled={createAddressIsPending}
            registration={register('streetAddress2', { required: false })}
            errors={errors.streetAddress2 as any}
          />
          <InputSM
            type='text'
            placeholder='Enter street address contd'
            label='Street contd'
            id='streetAddress3'
            showLabel
            disabled={createAddressIsPending}
            registration={register('streetAddress3', { required: false })}
            errors={errors.streetAddress3 as any}
          />
          <InputSM
            type='text'
            placeholder='Enter street address contd'
            label='Street contd'
            id='streetAddress4'
            showLabel
            disabled={createAddressIsPending}
            registration={register('streetAddress4', { required: false })}
            errors={errors.streetAddress4 as any}
          />
          <div className='grid sm:grid-cols-2 gap-x-[20px]'>
            <InputSM
              type='text'
              placeholder='Enter postcode'
              label='Postcode'
              id='postCode'
              showLabel
              disabled={createAddressIsPending}
              registration={register('postCode', {
                required: {
                  value: true,
                  message: 'Required'
                }
              })}
              errors={errors.postCode as any}
            />
            <InputSM
              type='text'
              placeholder='Enter city'
              label='City'
              id='city'
              showLabel
              disabled={createAddressIsPending}
              registration={register('city', {
                required: {
                  value: true,
                  message: 'Required'
                }
              })}
              errors={errors.city as any}
            />
          </div>
          <CheckboxInputSM
            label='Set as default address'
            id='chargeDirect'
            disabled={createAddressIsPending}
            registration={register('defaultItem')}
            errors={errors.defaultItem}
          />
          <ButtonRoundedSm type='submit' loading={createAddressIsPending} text='Save' />
        </form>
      </motion.div>
    </ModalContainer>
  )
}
